export default __webpack_public_path__ + "static/media/Capture.ba1fcc8d.png";